import React, { useMemo } from 'react';

import { useFreecodeContextRun, useFreecodeContextData } from 'hooks/useContext';
import { ApiContainer } from './styles';
import ApiMethod from './ApiMethod';

const genChallengeMethods = (apiChallenge, apiStrings, language) =>
  apiChallenge?.map((apiValue, index) => {
    return {
      header: apiStrings?.challenge?.[language]?.[index] || 'API string value undefined',
      description: apiValue?.description,
      challengeDescription: apiStrings?.challengeDescription?.[language]?.[index],
    };
  });

export default function FreecodeApi() {
  const { testImpl } = useFreecodeContextData();
  const { language } = useFreecodeContextRun();

  const apiContents = useMemo(
    () => genChallengeMethods(testImpl.api.challenge, testImpl.generated?.apiStrings, language),
    [testImpl.api, testImpl.generated, language]
  );

  return (
    <ApiContainer>
      {apiContents.map((apiMethod, index) => (
        <ApiMethod key={index} apiMethod={apiMethod} />
      ))}
    </ApiContainer>
  );
}
